import React from 'react';
import { FormattedMessage } from 'react-intl';

import { b } from 'utils/i18nUtils';
import { getHyperlink } from 'utils/linkUtils';

interface HelpTermsProps {
  confidentialityPolicyLink?: string;
  legalNotice?: string;
}

const HelpTerms: React.FC<HelpTermsProps> = ({ confidentialityPolicyLink, legalNotice }) => {
  const hasBothTerms = Boolean(legalNotice && confidentialityPolicyLink);

  return (
    <>
      <div className="w-full h-px my-4 kioskSharebox:my-6 kiosk:my-8 bg-border-default" />
      {legalNotice && (
        <FormattedMessage
          id="helpLine.LEGAL_NOTICE.privateTitle"
          defaultMessage="<a><b>Legal notice</b></a>"
          values={{ a: getHyperlink({ href: legalNotice, target: '_blank' }), b: (node) => b(node, 'text-s'), }}
          tagName="p"
        />)}
      {hasBothTerms && <div className="mb-s"/>}
      {confidentialityPolicyLink && (
        <FormattedMessage
          id="helpLine.CONFIDENTIAL_POLICY.privateTitle"
          defaultMessage="<a><b>Data Handling Policy</b></a>"
          values={{ a: getHyperlink({ href: confidentialityPolicyLink, target: '_blank' }), b: (node) => b(node, 'text-s'), }}
          tagName="p"
        />)}
    </>
  );};

export default HelpTerms;
